const ServiceAreaSection = () => {
  const locations = [
    'Mollet del Vallès',
    'Parets del Vallès',
    'Montmeló',
    'Montornès del Vallès',
    'La Llagosta',
    'Martorelles',
    'Granollers',
    'Santa Perpètua de Mogoda',
    'Sant Fost de Campsentelles',
    'Palau-solità i Plegamans',
    'Lliçà de Vall',
    'Lliçà d\'Amunt',
  ];

  const barrios = [
    'Centre',
    'Plana Lledó',
    'Can Borrell',
    'Santa Rosa',
    'Lourdes',
    'Riera Seca',
    'Can Pantiquet',
    'Gallecs',
  ];

  return (
    <section className="py-24 bg-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Servicio en Mollet del Vallès y Comarca
            </h2>

            <p className="text-white/85 text-lg leading-relaxed mb-8">
              Ofrecemos nuestros servicios de vaciado de pisos, vaciado de locales, retirada de muebles y limpieza por síndrome de Diógenes en Mollet del Vallès y en todos los municipios del Vallès Oriental. Conocemos perfectamente la zona y trabajamos con la máxima rapidez y eficiencia.
            </p>

            <div className="mb-8">
              <h3 className="text-xl font-semibold mb-4">Barrios de Mollet del Vallès:</h3>
              <div className="flex flex-wrap gap-2">
                {barrios.map((barrio, index) => (
                  <span
                    key={index}
                    className="bg-primary text-white px-4 py-2 rounded-full text-sm font-medium"
                  >
                    {barrio}
                  </span>
                ))}
              </div>
            </div>

            <a
              href="/contacto"
              className="inline-flex items-center space-x-2 text-white hover:text-primary transition-colors duration-200 font-medium cursor-pointer"
            >
              <span>Ver todas las zonas de servicio</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-6 text-center">
                Localidades donde trabajamos
              </h3>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {locations.map((location, index) => (
                  <div
                    key={index}
                    className="flex items-center space-x-3 bg-white/5 rounded-lg p-3 hover:bg-white/10 transition-colors duration-200"
                  >
                    <i className="ri-map-pin-fill text-primary text-xl flex-shrink-0"></i>
                    <span className="text-sm font-medium">{location}</span>
                  </div>
                ))}
              </div>

              <div className="mt-8 text-center">
                <p className="text-white/70 text-sm">
                  ¿Tu localidad no aparece? Llámanos, también trabajamos en municipios cercanos del Vallès Oriental y Barcelona.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaSection;